import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { selectAccountIsLoading } from '@/store/selectors';
import { checkAuth, login } from '@/store/thunks/account';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';

interface ILoginForm {
    login: string,
    password: string
}

interface IUseLogin {
    form: ILoginForm;
    isLoading: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onSubmit: () => void;
}

export const useLogin = (): IUseLogin => {
    const dispatch = useAppDispatch();

    const isLoading = useAppSelector(selectAccountIsLoading);

    const [form, setForm] = useState<ILoginForm>({
        login: '',
        password: '',
    });

    const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    }, [form]);

    const onSubmit = useCallback(() => {
        dispatch(login(form));
    }, [dispatch, form]);

    useEffect(() => {
        dispatch(checkAuth());
    }, [dispatch]);

    return { form, isLoading, onChange, onSubmit };
};
